import { alpha, Theme } from '@mui/material/styles';

export const HOUR_ROW_HEIGHT = 50;
export const DAY_START_HOUR = 8;
export const DAY_END_HOUR = 20;

type StyleObject = Record<string, unknown>;

export const reservationOwnSx = (theme: Theme): StyleObject => ({
  bgcolor: alpha(theme.palette.success.main, 0.12),
  color: theme.palette.success.dark,
  borderLeft: `3px solid ${theme.palette.success.main}`,
});

export const reservationOtherSx = (theme: Theme): StyleObject => ({
  bgcolor: alpha(theme.palette.primary.main, 0.12),
  color: theme.palette.primary.dark,
  borderLeft: `3px solid ${theme.palette.primary.main}`,
});

export const pastDaySx = (theme: Theme): StyleObject => ({
  bgcolor: alpha(theme.palette.grey[500], 0.08),
  color: theme.palette.text.disabled,
});

export const todayColumnSx = (theme: Theme): StyleObject => ({
  bgcolor: alpha(theme.palette.primary.main, 0.06),
  borderLeft: `3px solid ${theme.palette.primary.main}`,
});

export const todayHeaderSx = (theme: Theme): StyleObject => ({
  bgcolor: alpha(theme.palette.primary.main, 0.1),
  color: theme.palette.primary.dark,
  borderRadius: 1,
  border: '1px solid',
  borderColor: alpha(theme.palette.primary.main, 0.4),
});

export const toolbarSx: StyleObject = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: 0,
  p: 2,
  borderBottom: 1,
  borderColor: 'divider',
  position: 'sticky',
  top: 0,
  zIndex: 2,
  bgcolor: 'background.paper',
};

export const focusVisibleSx: StyleObject = {
  '&:focus-visible': {
    outline: '2px solid',
    outlineColor: 'primary.main',
    outlineOffset: 2,
  },
};

export const upcomingCardSx = (theme: Theme): StyleObject => ({
  borderLeft: `4px solid ${theme.palette.success.main}`,
  bgcolor: alpha(theme.palette.success.main, 0.04),
});

export const pastCardSx = (theme: Theme): StyleObject => ({
  borderLeft: `4px solid ${theme.palette.warning.main}`,
  bgcolor: alpha(theme.palette.warning.main, 0.04),
});

export const ruleCardSx: StyleObject = {
  p: 2.5,
  height: '100%',
  display: 'flex',
  gap: 2,
  alignItems: 'flex-start',
  border: 1,
  borderColor: 'divider',
  borderRadius: 2,
  transition: 'box-shadow 0.2s',
  '&:hover': {
    boxShadow: 2,
  },
};
